<template>
    <aside class="asideMenue">

        <!-- sidebar: style can be found in sidebar.less -->
        <section class="sidebar" style="min-height: 900px">

            <!-- search form (Optional) -->
            <form v-on:submit.prevent class="sidebar-form">
                <div class="input-group">
                    <input type="text"
                           name="search"
                           id="search"
                           class="search form-control"
                           data-toggle="hideseek"
                           placeholder="Search Menus"
                           data-list=".sidebar-menu">
          <span class="input-group-btn">
            <button
                id="search-btn"
                type="submit"
                name="search"
                class="btn btn-flat">
              <i class="fa fa-search"></i>
            </button>
          </span>
                </div>
            </form>
            <!-- /.search form -->

            <!-- Sidebar Menu -->
            <sidebar-menu />
            <!-- /.sidebar-menu -->
        </section>
        <!-- /.sidebar -->
    </aside>
</template>
<script>
    import SidebarMenu from './SidebarMenu'

    export default {
        name: 'Sidebar',
        components: { SidebarMenu }
    }
</script>
<style>
    .user-panel .image img {
        border-radius: 50%;
    }
    .main-sidebar{
        padding-top: 0!important;
    }
    .asideMenue{
        float: left;
        /* margin-left: 35px; */
        width: 296px;
    }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?994ec662